window.ng_migrate = window.ng_migrate || {};

ng_migrate.homeSlider = function () {
  // add current class to first items
  $('a[data-imageslide="1"]').addClass("homeslider__currentimage");
  $('li[data-listitem="1"]').addClass("homeslider__currentlistitem");

  // then every five seconds remove and add classes
  var home_slider_interval = setInterval(function() {
    var slideshow_length = $(".homeslider__image").length;

    // get current image
    var current_slide_number = $(".homeslider__currentimage").removeClass("homeslider__currentimage").data("imageslide");
    var next_slide = current_slide_number + 1;

    if (next_slide > slideshow_length) {
      next_slide = 1;
    }

    // add a class to the image
    $('a[data-imageslide="' + next_slide + '"]').addClass("homeslider__currentimage");

    // remove the current class from list item
    $(".homeslider__currentlistitem").removeClass("homeslider__currentlistitem")

    // add a class to the list item
    $('li[data-listitem="' + next_slide + '"]').addClass("homeslider__currentlistitem");
  }, 5000);
};

ng_migrate.homeSlider();